import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttendanceRoutingModule } from './attendance-routing.module';
import { KnownIpAddressModule } from './known-ip-address/known-ip-address.module';
import { WorkLocationModule } from './work-location/work-location.module';
import { UserPresenceHistoryModule } from './user-presence-history/user-presence-history.module';
import { WorkScheduleModule } from './work-schedule/work-schedule.module';
import { AttendanceDashboardModule } from './attendance-dashboard/attendance-dashboard.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AttendanceRoutingModule,
    KnownIpAddressModule,
    WorkLocationModule,
    UserPresenceHistoryModule,
    WorkScheduleModule,
    AttendanceDashboardModule,
  ],
})
export class AttendanceModule {}
